import checkout from '../../api/checkout'
import jwt from 'jsonwebtoken'
import * as auth from '../../api/auth/auth'

const token = `${auth.token()}`

const cardFormaPagamento = (cardFlag) => {
  switch (cardFlag.toLowerCase()) {
    case 'visa':
      return 1
    case 'mastercard':
      return 2
    case 'amex':
      return 4
    case 'elo':
      return 14
    case 'diners':
      return 3
    default:
      break
  }
}

const cardCodicaoPagamento = (cardFlag) => {
  switch (cardFlag.toLowerCase()) {
    case 'visa':
      return 1
    case 'mastercard':
      return 5
    case 'amex':
      return 4
    case 'elo':
      return 18
    case 'diners':
      return 6
    default:
      break
  }
}

export const converterNegociacaoCartao = async (
  operacao,
  pagamento,
  tipo,
  cardFlag
) => {
  const body = {
    IdCotacaoNegociacao: operacao.Id,
    Tipo: tipo,
    // FormaPagamento: cardFormaPagamento(cardFlag),
    // CondicaoPagamento: cardCodicaoPagamento(cardFlag),
    FormaPagamento: operacao.DetalhePagamento.IdFormaPagamento,
    CondicaoPagamento: operacao.DetalhePagamento.IdCondicaoPagamento,
    PercentualJuros: operacao.DetalhePagamento.Juros,
    NumeroParcela: operacao.DetalhePagamento.QuantidadeParcelas,
    ValorParcela: operacao.DetalhePagamento.ValorParcelas,
    PercentualDesconto: 0,
    ValorST: operacao.ValorSubstituicaoTributaria,
    ValorFcp: 0,
    ItensST: 0,
    TextoNotaFiscal: operacao.ObservacaoCliente,
    TipoPagamento: 1,
    MeioPagamento: '',
    ValorDescontoFormaPagamento:
      operacao.DetalhePagamento.DescontoFormaPagamento,
    nomeCartao: pagamento?.cardName || null,
    numeroCartao: pagamento?.cardNumber || null,
    bandeiraCartao: cardFlag,
    segurancaCartao: pagamento?.cardCvv || null,
    mesCartao: pagamento?.cardMonth || null,
    anoCartao: pagamento?.cardYear || null,
    tokenCartao: pagamento.Token || null,
    TokenBearer: token
  }

  // console.log('Body', body)
  // console.log('Flag', cardFlag)

  let res = await checkout.converterCotacaoNegociacaoEmPedido(body)
  res = await res.json()
  return res
}

export const converterNegociacaoBoleto = async (operacao, tipo) => {
  const body = {
    IdCotacaoNegociacao: operacao.Id,
    Tipo: tipo,
    FormaPagamento: operacao.DetalhePagamento.IdFormaPagamento,
    CondicaoPagamento: operacao.DetalhePagamento.IdCondicaoPagamento,
    PercentualJuros: operacao.DetalhePagamento?.Juros,
    NumeroParcela: operacao.DetalhePagamento?.QuantidadeParcelas,
    ValorParcela: operacao.DetalhePagamento?.ValorParcelas,
    PercentualDesconto: 0,
    ValorST: operacao.ValorSubstituicaoTributaria,
    ValorFcp: 0,
    ItensST: 0,
    TextoNotaFiscal: operacao.ObservacaoCliente,
    TipoPagamento: 3,
    MeioPagamento: operacao.DetalhePagamento?.DescricaoFormaPagamento,
    ValorDescontoFormaPagamento:
      operacao.DetalhePagamento?.DescontoFormaPagamento,
    TokenBearer: token
  }

  // console.log('Body', body)
  let res = await checkout.converterCotacaoNegociacaoEmPedido(body)
  res = await res.json()
  return res
}
